export enum SessionPath {
  CONTEXT = 'session.contextTarget',
  OAUTH = 'session.oAuth',
  USER = 'session.user',
  TARGETS = 'session.targets',
}
